import React, { Component } from 'react'
import S from 'shorti'
class ListingSearch extends Component {
  render() {
    const listings = this.props.listings
    if (!listings)
      return <div></div>
    const listings_found = listings.map(listing => {
      let cover_image = <div style={ S(`br-3 bg-ccc w-100 h-70 pull-left mr-10`) }></div>
      if (listing.cover_image_url)
        cover_image = <div style={ S(`br-3 bg-url(${listing.cover_image_url}) bg-cover bg-center w-100 h-70 pull-left mr-10`) }></div>
      return (
        <div key={ 'listing-' + listing.id } style={ S('p-5 pointer') } onClick={ this.props.handleListingClick.bind(this, listing) }>
          { cover_image }
          <div style={ S('pull-left p-5 w-60p font-12') }>
            <div><span style={ S('fw-600') }>{ `${listing.address.street_number} ${listing.address.street_name} ${listing.address.city}, ${listing.address.state}` }</span> <span>{ listing.status }</span></div>
            <div>{ `MLS#${listing.mls_number}` }</div>
          </div>
          <div className="clearfix"></div>
        </div>
      )
    })
    return <div>{ listings_found }</div>
  }
}
export default ListingSearch


// WEBPACK FOOTER //
// ./src/components/Partials/ListingSearch/index.js